import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import { BannerDetails_banner_product } from "@saleor/banners/types/BannerDetails";
import CardTitle from "@saleor/components/CardTitle";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableHead from "@saleor/components/TableHead";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
export interface BannerProductsProps {
  product: BannerDetails_banner_product;
  disabled?: boolean;
  onProductAssign?: () => void;
  onProductUnassign?: (id: string) => void;
  onRowClick: (id: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    buttonDisabled: {
      "& > span": {
        color: "#616161"
      }
    },
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colEmpty: {
      width: "1px"
    },
    colName: {
      paddingLeft: 0,
      width: 230
    },
    colNameLabel: {},
    colPrice: {
      textAlign: "center",
      width: 100
    },
    colPublished: {
      width: 150
    },
    colSKU: {
      "@media (min-width: 769px)": {
        wordBreak: "break-all"
      },
      width: 150
    },
    colType: {
      width: 150
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "BannerProducts" }
);

const numberOfColumnsVoucher = 3;

const BannerProducts: React.FC<BannerProductsProps> = props => {
  const { product, onProductAssign, onProductUnassign, disabled } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  function showProductTable() {
    const productData = product ? [product] : [];

    return (
      <ResponsiveTable className={classes.table}>
        <colgroup>
          <col className={classes.colName} />
          <col className={classes.colType} />
          <col className={classes.colActions} />
        </colgroup>
        <TableHead
          colSpan={numberOfColumnsVoucher}
          disabled={false}
          hideCheckBox
          items={productData}
          toggleAll={null}
          toolbar={toolbar}
        >
          <TableCell className={classes.colName}>
            <span className={classes.colNameLabel}>
              <FormattedMessage defaultMessage="Product Name" />
            </span>
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="Product Type" />
          </TableCell>
          <TableCell className={classes.colActions} />
        </TableHead>
        <TableBody>
          {renderCollection(
            productData,
            (product, index) => (
              <TableRow
                hover={!!product}
                key={product ? product.id : "skeleton"}
                className={classes.tableRow}
              >
                <TableCell
                  className={classes.colName}
                  id={`productNameRow${index}`}
                >
                  {maybe<React.ReactNode>(() => product.name, <Skeleton />)}
                </TableCell>
                <TableCell
                  className={classes.colType}
                  id={`productTypeRow${index}`}
                >
                  {maybe<React.ReactNode>(
                    () => product.productType.name,
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell
                  className={classes.colActions}
                  id={`productUnassignBtnRow${index}`}
                >
                  <IconButton
                    disabled={!product}
                    onClick={event => {
                      event.stopPropagation();
                      onProductUnassign(product.id);
                    }}
                  >
                    <DeleteIcon color="primary" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={numberOfColumnsVoucher}>
                  <FormattedMessage defaultMessage="Click Assign Product to add a featured product in this list" />
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </ResponsiveTable>
    );
  }

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Featured Product",
          description: "section header"
        })}
        toolbar={
          <Button
            id="assignProductBtn"
            disabled={!!product || disabled}
            color="primary"
            className={!!product || disabled ? classes.buttonDisabled : null}
            onClick={onProductAssign}
          >
            <FormattedMessage
              defaultMessage="Assign product"
              description="button"
            />
          </Button>
        }
      />
      {showProductTable()}
    </Card>
  );
};
BannerProducts.displayName = "BannerProducts";
export default BannerProducts;
